<script setup lang="ts">
import logo from '@solusign/platform/assets/logo-solusign.svg';
import { onMounted } from 'vue';
import AppIcon from './components/AppIcon.vue';

// Toujours en clair, quel que soit le réglage de l'appareil : le signataire doit
// voir le PDF, ses champs et sa signature tels qu'ils seront scellés.
onMounted(() => {
  const root = document.documentElement;
  root.classList.remove('app-dark');
  root.setAttribute('data-theme', 'light');
});
</script>

<template>
  <div class="signer-shell">
    <!-- Header minimal : la marque seule. Pas de navigation — le signataire
         n'a qu'une tâche. -->
    <header class="signer-header">
      <span class="signer-brand">
        <img class="signer-logo" :src="logo" alt="Solusign" />
      </span>
      <span class="signer-secure" data-testid="header-secure">
        <AppIcon name="lock" :size="14" />
        <span>Page sécurisée</span>
      </span>
    </header>

    <main class="signer-main">
      <router-view />
    </main>
  </div>
</template>

<style scoped>
.signer-shell {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  padding: env(safe-area-inset-top) env(safe-area-inset-right) 0 env(safe-area-inset-left);
  background: var(--solusign-bg);
  color: var(--solusign-fg);
}

/* Même langage que la topbar de la console : hauteur 64px, fond fondu dans le
   fond de page (pas une surface blanche), filet bas. */
.signer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--solusign-spacing-3);
  min-height: 64px;
  padding: var(--solusign-spacing-3) var(--solusign-spacing-6);
  background: var(--solusign-topbar-bg);
  border-bottom: 1px solid var(--solusign-topbar-border);
}

.signer-brand {
  display: inline-flex;
  align-items: center;
  gap: var(--solusign-spacing-2);
}
.signer-logo {
  display: block;
  height: 28px;
  width: auto;
}
.signer-secure {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--solusign-text-xs);
  font-weight: 500;
  color: var(--solusign-muted);
}

.signer-main {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

@media (max-width: 480px) {
  .signer-header {
    min-height: 56px;
    padding: var(--solusign-spacing-2) var(--solusign-spacing-4);
  }
  .signer-logo {
    height: 24px;
  }
}
</style>
